import { loadConfig } from './config'
import type { AppConfig } from './config'

export const config: AppConfig = loadConfig(import.meta.env as Record<string, string | undefined>)
